/* This file was generated automatically. Do not edit manually. */

export enum SalesforceCaseCategory {
    ApiDevelopers = 'ApiDevelopers',
    BusinessIntelligenceReports = 'BusinessIntelligenceReports',
    GuestJourneyBookingEngine = 'GuestJourneyBookingEngine',
    GuestJourneyKiosk = 'GuestJourneyKiosk',
    MarketplaceChannelManager = 'MarketplaceChannelManager',
    MarketplaceRevenueManagement = 'MarketplaceRevenueManagement',
    MySubscriptionInvoicePayments = 'MySubscriptionInvoicePayments',
    OperationsBilling = 'OperationsBilling',
    OperationsRateManagement = 'OperationsRateManagement',
    OperationsReservationManagement = 'OperationsReservationManagement',
    OperationsSettings = 'OperationsSettings',
    Other = 'Other',
    PaymentsRefunds = 'PaymentsRefunds',
    PaymentsTerminal = 'PaymentsTerminal',
    Restaurants = 'Restaurants',
}
